import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "children"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 10:42:23
 * @LastEditTime: 2021-07-02 15:03:18
 * @LastEditors: wangshengqiang
 * @Description: TODO
 */
import React from 'react';
import classnames from 'classnames';
import { createGlobalStyle } from 'styled-components';
import Module from '@/components/Module';
const Info = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    children
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const cls = classnames({
    'components-info-render': true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement(Module, _extends({
    className: cls,
    ref: ref
  }, others), children, /*#__PURE__*/React.createElement(GlobalStyled, null));
});
const GlobalStyled = createGlobalStyle`
  #container {
    padding-bottom: 60px!important;
  }
`;
export default Info;